import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'brigade_assignments'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'Inmueble' },
  SECTOR: false,
  CENTER: {},
  MUNICIPALITY: { label: 'Municipio', column: 'municipalities.name' },
  STATUS: { label: 'Estatus', column: 'brigade_status_catalog.name' },
  REGION: { label: 'Region', column: 'sectors.name' },
  TENANT: false,
  USER: { label: 'Usuario', column: 'users_rh.soeid' },
  PROFILE: false,
})

export default {
  key: DATASET_KEY,
  label: 'Brigadas',
  timeColumn: 'brigade_assignments.created_at',
  permission: { action: 'read', subject: 'Brigade' },

  tables: {
    brigade_assignments: ["id", "id_brigade", "id_unit_floor", "id_user_rh", "id_brigade_role", "id_brigade_training", "id_brigade_status_catalog", "id_brigade_status_catalog_assignment", "id_brigade_status_catalog_training", "assignment_date", "notification_expiring_soon_sent", "created_at", "updated_at"],
    brigades: ["id", "id_unit", "name", "status", "attachments", "created_at", "updated_at"],
    brigade_roles: ["id", "name", "short_name", "created_at", "updated_at"],
    brigade_status_catalog: ["id", "name", "created_at", "updated_at"],
    brigade_trainings: ["id", "id_brigade_status_catalog", "id_user_rh", "id_role", "name", "training_date", "training_type", "notification_expiring_soon_sent", "is_completed", "created_at", "updated_at"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
    municipalities: [],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    users_rh: ["id", "name", "first_name", "second_name", "soeid", "email", "is_active", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
  },

  csvConfig: {
    withTables: 'brigade_assignments',
    columns: 'brigades.status,brigades.status,users_rh.soeid,users_rh.name,users_rh.first_name,users_rh.second_name,units.description,unit_floors.floor_number,sectors.name,municipalities.name,centers.name,brigade_roles.name,brigade_trainings.training_type,brigade_assignments.created_at,brigade_trainings.training_date',
    exceptColumns: 'brigades.name,brigade_assignments.id_brigade,brigade_assignments.id_unit_floor,brigade_assignments.id_user_rh,brigade_assignments.id_brigade_role,brigade_assignments.id_brigade_status_catalog,brigade_assignments.id_brigade_status_catalog_assignment,brigade_assignments.notification_expiring_soon_sent,brigade_assignments.id_brigade_status_catalog_training,brigade_assignments.id_brigade_training,brigade_assignments.assignment_date',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
    //timeseries: { trendline: true },
  },

  fields: [
    { key: 'units.description', label: 'Inmueble' },
    { key: 'users_rh.soeid', label: 'SOEID' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'brigades.name', label: 'Brigada' },
    { key: 'brigades.status', label: 'Estatus de la brigada' },
    { key: 'brigade_roles.name', label: 'Rol' },
    { key: 'brigade_status_catalog.name', label: 'Estatus' },
    { key: 'brigade_trainings.training_type', label: 'Tipo de capacitación' },
    { key: 'brigade_assignments.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'brigade_roles.name', 'Rol', 'role'),
    embedFilter(DATASET_KEY, 'brigades.name', 'Brigadas', 'brigades'),
    embedFilter(DATASET_KEY, 'brigades.status', 'Estatus de la brigada', 'brigade_status'),
    embedFilter(DATASET_KEY, 'brigade_trainings.training_type', 'Tipo de capacitación', 'training_type'),
  ],

  dateGrouping: {
    column: 'brigade_assignments.created_at',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
